import clsx from "clsx";
import type { ReactNode, HTMLAttributes } from "react";
import { forwardRef } from "react";

import styles from "./root.module.css";

type Props = HTMLAttributes<HTMLElement> & {
    children: ReactNode;
};

const Root = forwardRef<HTMLElement, Props>((props, ref) => {
    const { children, className, ...otherProps } = props;

    return (
        <nav {...otherProps} ref={ref} className={clsx(styles.sidebar, className)}>
            {children}
        </nav>
    );
});

Root.displayName = "Sidebar";

export { Root };
export type { Props as RootProps };
